import { useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Home from './components/Home'
import Features from './components/Features'
import Info from './components/Info'
import InfoContacte from './components/InfoContacte'
import InfoLegal from './components/InfoLegal'
import NavBar from './components/NavBar'
import NavBar2 from './components/NavBar2'
import Digitalitza from './components/Funcionalitats/Digitalitza'
import Transcripcio from './components/Funcionalitats/Transcripcio'
import Updates from './components/Updates'
import Footer from './components/Footer'

import styles from './App.module.css'

function App() {

  const [ open, setOpen ] = useState(false)
  const [language, setLanguage] = useState(navigator.language || navigator.userLanguage)

  return (
    <Router>
      <div className={styles.app}>
        <header className={styles.header}>
            <NavBar open={open} setOpen={setOpen} language={language} className={styles.navbar}/>
            {open === true && <NavBar2 className={styles.navbar2} setOpen={setOpen} language={language} open={open}/>}
        </header>
        <TransitionGroup className={styles.transition_group} onClick={() => setOpen(false)}>
          <Routes>
            <Route path="/" element={<PageWrapper><Home language={language}/></PageWrapper>} />
            <Route path="/features" element={<PageWrapper><Features language={language}/></PageWrapper>} />
            <Route path="/info" element={<PageWrapper><Info language={language}/></PageWrapper>} />
            <Route path="/info-contacte" element={<PageWrapper><InfoContacte language={language}/></PageWrapper>} />
            <Route path="/info-legal" element={<PageWrapper><InfoLegal language={language}/></PageWrapper>} />
            <Route path="/digitalitza" element={<PageWrapper><Digitalitza language={language}/></PageWrapper>} />
            <Route path="/transcripcio" element={<PageWrapper><Transcripcio language={language}/></PageWrapper>} />
            <Route path="/next" element={<PageWrapper><Updates language={language}/></PageWrapper>} />
          </Routes>
        </TransitionGroup>
        <footer className={styles.footer}>
          <Footer language={language}/>
        </footer>
      </div>
    </Router>
  )
}

// Wrapper para aplicar animaciones consistentes a las páginas
function PageWrapper({ children }) {
  return (
    <CSSTransition timeout={300} classNames="fade" appear>
      <div className="page-content">
        {children}
      </div>
    </CSSTransition>
  );
}

export default App;
